<div class="form-group">
  <div class="input-group">
    <mat-checkbox #id (ngModelChange)="change(id)"
                  [disabled]="disabled" [ngModel]="valor">
      <ng-content></ng-content>
    </mat-checkbox>
  </div>
</div>
